import { createElement, Component } from 'react'

export default function periodically({
  fn = props => {},
  interval = 1000,
  heading = true,
  trailing = false,
}) {
  return OriginalComponent => {
    return class PeriodicallyCall extends Component {
      render() {
        return createElement(OriginalComponent, this.props, this.props.children)
      }

      componentDidMount() {
        if (heading) {
          this.callFn()
        }
        this.intervalHandle = setInterval(this.callFn, interval)
      }

      componentWillUnmount() {
        clearInterval(this.intervalHandle)
        if (trailing) {
          this.callFn()
        }
      }

      callFn = () => {
        fn(this.props)
      }
    }
  }
}
